export default __webpack_public_path__ + "static/media/undo.73cd2865.svg";